import { ItemDropdown } from './models/activity-log';

export const MAX_POST_LENGTH = 260;
export const MAX_CAPTION_LENGTH = 80;
export const MAX_RESOLUTION_OF_POST = 703;
export const MAX_TRUNCATED_TEXT_HEIGHT = 100;
export const MAX_QTY_REACTIONS_STORAGE = 1000;

export const DAY_TIME_UNITS = {
  milisecond: 'milisecond',
  second: 'second',
  minute: 'minute',
  hour: 'hour',
  day: 'day'
};

export const UserStatus = {
  warn: {
    id: 'WARNING',
    label: 'USER_MANAGEMENT.USER_STATUS.WARNED',
    icon: 'sctr-icon-info-circle'
  },
  inactive: {
    id: 'INACTIVE',
    label: 'USER_MANAGEMENT.USER_STATUS.INACTIVE',
    icon: 'sctr-icon-check-circle'
  },
  active: {
    id: 'ACTIVE',
    icon: 'sctr-icon-check-circle',
    label: 'USER_MANAGEMENT.USER_STATUS.ACTIVE'
  },
  block: {
    id: 'BLOCKED',
    icon: 'sctr-icon-lock-03',
    label: 'USER_MANAGEMENT.USER_STATUS.BLOCKED'
  },
  // limit: {
  //   id: 'LIMITED',
  //   icon: 'sctr-icon-alert-hexagon',
  //   label: 'Limited'
  // },
  delete: {
    id: 'DELETED',
    label: 'USER_MANAGEMENT.USER_STATUS.DELETED',
    icon: 'sctr-icon-trash-02'
  },
  // edit: {
  //   id: 'EDIT',
  //   label: 'Edit',
  //   icon: 'sctr-icon-edit-05'
  // },
  // unBlock: {
  //   id: 'UNBLOCK',
  //   label: 'Unblock',
  //   icon: 'sctr-icon-check-circle'
  // },
  scheduleDeleted: {
    id: 'SCHEDULED_DELETED',
    label: 'USER_MANAGEMENT.USER_STATUS.SCHEDULED_DELETED',
    icon: ''
  }
};

export const StatusList = [
  { label: UserStatus.active.label, id: UserStatus.active.id },
  { label: UserStatus.block.label, id: UserStatus.block.id },
  { label: UserStatus.inactive.label, id: UserStatus.inactive.id },
  { label: UserStatus.delete.label, id: UserStatus.delete.id },
  { label: UserStatus.scheduleDeleted.label, id: UserStatus.scheduleDeleted.id },
  { label: UserStatus.warn.label, id: UserStatus.warn.id }
];

export const AccountTypeList = [
  { label: 'NORMAL', id: 0 }, // person
  { label: 'NON_NORMAL_USER', id: 1 } // bot
];

export const UserRoles = [
  {
    name: 'User',
    code: 'USER'
  },
  {
    name: 'Restricted',
    code: 'RESTRICTED'
  },
  {
    name: 'Administrator',
    code: 'ADMINISTRATOR'
  },
  {
    name: 'Admin',
    code: 'ADMIN'
  }
];

export const ModerateRole = {
  SUPER_ADMIN: {
    name: 'Super Admin',
    code: 'SUPER_ADMIN'
  },
  ADMIN: {
    name: 'Admin',
    code: 'ADMIN'
  },
  MANAGER: {
    name: 'Manager',
    code: 'MANAGER'
  },
  LEADER: {
    name: 'Leader',
    code: 'LEADER'
  },
  MEMBER: {
    name: 'Member',
    code: 'MEMBER'
  },
  COLLABORATORS: {
    name: 'Collaborators',
    code: 'COLLABORATORS'
  }
};

export const ManagementRoles = [
  {
    name: 'Super Admin',
    code: 'SUPER_ADMIN',
    level: 30
  },
  {
    name: 'Admin',
    code: 'ADMIN',
    level: 25
  },
  {
    name: 'Manager',
    code: 'MANAGER',
    level: 20
  },
  {
    name: 'Leader',
    code: 'LEADER',
    level: 15
  },
  {
    name: 'Member',
    code: 'MEMBER',
    level: 10
  },
  {
    name: 'Collaborators',
    code: 'COLLABORATORS',
    level: 5
  }
];

export const Genders: ItemDropdown[] = [
  { label: 'None', value: null },
  { label: 'Male', value: 'Male' },
  { label: 'Female', value: 'Female' }
];

export const PhoneNumber: ItemDropdown[] = [
  { label: 'VN (+84)', value: 'VN' },
  { label: 'Lao (+85)', value: 'L' }
];

export const Locations: any[] = [
  { value: 'Ho Chi Minh' },
  { value: 'Ha Noi' },
  { value: 'Binh Dinh' },
  { value: 'Da Nang' },
  { value: 'Khanh Hoa' },
  { value: 'Ben Tre City' }
];

export const Hometowns: any[] = [
  { name: 'Da Nang', value: 'DN' },
  { name: 'Khanh Hoa', value: 'KH' }
];

export const Links: any[] = [
  { value: 'Facebook' },
  { value: 'Twitter' },
  { value: 'LinkedIn' },
  { value: 'Instagram' }
];

export const RelationshipStatus: any[] = [
  { label: 'None', value: null },
  { label: 'Single', value: 'Single' },
  { label: 'In Relationship', value: 'In Relationship' },
  { label: 'Married', value: 'Married' },
  { label: 'In a civil union', value: 'In a civil union' },
  { label: 'Separated', value: 'Separated' },
  { label: 'Divorced', value: 'Divorced' },
  { label: 'Widowed', value: 'Widowed' }
];

export const Status: any[] = [
  { name: 'Active', value: 'A' },
  { name: 'Inactive', value: 'I' },
  { name: 'Blocked', value: 'B' },
  { name: 'Limited', value: 'L' },
  { name: 'Activate', value: 'AT' }
];

export const ActivityLogItem: any[] = [
  {
    'name': 'commented',
    'icon': 'sctr-icon-message-dots-square',
    'color': 'bg-palette-blue-50',
    'color-icon': 'text-palette-blue-600',
    'valueFilter': 'Comment'
  },
  {
    'name': 'shared',
    'icon': 'sctr-icon-repeat-01',
    'color': 'bg-palette-emerald-50',
    'color-icon': 'text-palette-emerald-600',
    'valueFilter': 'Share'
  },
  {
    'name': 'created',
    'icon': 'sctr-icon-flag-03',
    'color': 'bg-palette-blue-light-50',
    'color-icon': 'text-palette-blue-light-500',
    'valueFilter': 'Post'
  },
  {
    'name': 'reported',
    'icon': 'sctr-icon-alert-triangle',
    'color': 'bg-[#EAECF5]',
    'color-icon': 'text-[#363F72]',
    'valueFilter': 'Report'
  },
  {
    'name': 'sent coins',
    'icon': 'sctr-icon-coins-hand',
    'color': 'bg-palette-amber-50',
    'color-icon': 'text-palette-amber-500',
    'valueFilter': 'Gift'
  },
  {
    'name': 'reacted',
    'icon': 'sctr-icon-heart',
    'color': 'bg-palette-pink-50',
    'color-icon': 'text-palette-pink-600',
    'valueFilter': 'React'
  },
  // TODO - No UI for each element below
  {
    'name': 'edited',
    'icon': '',
    'color': '',
    'color-icon': '',
    'valueFilter': 'Edit'
  },
  {
    'name': 'blocked',
    'icon': '',
    'color': '',
    'color-icon': '',
    'valueFilter': 'Block'
  },
  {
    'name': 'deleted',
    'icon': '',
    'color': '',
    'color-icon': '',
    'valueFilter': 'Delete'
  },
  {
    'name': 'activated',
    'icon': '',
    'color': '',
    'color-icon': '',
    'valueFilter': 'Activate'
  }
];

export const DefaultPaginator = {
  numberRowPerPage: 10,
  rowsPerPageOptions: [10, 30, 50]
};

export const POST_TYPE = {
  user: 'USER',
  livestream: 'LIVESTREAM',
  suggestion: 'SUGGESTIONS',
  ads: 'ADS'
};

export const POST_PATTERN = {
  normal: 'NORMAL',
  share: 'SHARE',
  album: 'ALBUM',
  link: 'LINK'
};

export const STORAGE_TYPE = {
  thumbnail: 'thumbnail',
  streamVideo: 'stream-video'
};

export const MEDIA_TYPE = {
  image: 'IMAGE',
  video: 'VIDEO'
};

export const FILE_EXTENSION = {
  image: '.webp',
  video: '.webm',
  mp4: '.mp4'
};

export const LAYOUT_TYPE = {
  vertical: 'VERTICAL',
  horizontal: 'HORIZONTAL',
  sidelong: 'SIDELONG',
  central: 'CENTRAL'
};

export const MEDIA_FILE_SIZE_LIMITS_BYTES = {
  image: 5242880,
  video: 104857600
};

export const MEDIA_FILE_FORMAT_LIMITS = {
  image: [
    'image/avif',
    'image/jpeg',
    'image/png',
    'image/gif',
    'image/jpg',
    'image/bmp',
    'image/svg+xml',
    'image/webp',
    'image/tiff'
  ],
  video: [
    'video/mp4',
    'video/mpeg',
    'video/ogg',
    'video/webm',
    'video/3gpp',
    'video/x-msvideo',
    'video/x-ms-wmv',
    'video/quicktime'
  ]
};

export const TOAST_MESSAGE_SEVERITY_LEVELS = {
  warn: 'warn',
  info: 'info',
  success: 'success',
  error: 'error'
};

export const TOAST_MESSAGE_LIFETIME_DURATIONS = {
  short: 2000,
  medium: 5000,
  long: 7000
};

export const APPROVER_TYPE = {
  superAdmin: 'SuperAdmin',
  adminGroup: 'AdminGroup',
  adminPage: 'AdminPage'
};

export const OBJECT_TYPE = {
  post: 'Post',
  group: 'Group',
  page: 'Page',
  tour: 'Tour',
  rating: 'Rating',
  comment: 'Comment',
  food: 'Food',
  hotel: 'Hotel'
};

export const PRIVACY = {
  public: 'PUBLIC',
  private: 'PRIVATE',
  friends: 'FRIENDS',
  friendExcept: 'FRIEND_EXCEPT',
  groupMembers: 'GROUP_MEMBERS'
};

export const PRIVACY_OPTIONS = [
  { privacy: PRIVACY.public, label: 'Public', icon: 'sctr-icon-globe-04' },
  { privacy: PRIVACY.private, label: 'Private', icon: 'sctr-icon-user-01' },
  { privacy: PRIVACY.friends, label: 'Friends', icon: 'sctr-icon-users-01' },
  { privacy: PRIVACY.friendExcept, label: 'Friend Except', icon: 'sctr-icon-settings-02' }
];

export const MODULE_TYPE = {
  verificationRequest: 'VERIFICATION_REQUEST',
  comments: 'Comments',
  fanpage: 'Fanpage',
  group: 'Group',
  posts: 'Posts'
};

export const SORT_BY_DATE = {
  DESCENDING: 'DESCENDING',
  ASCENDING: 'ASCENDING'
};

export const REPORT_STATUS = {
  NONE: 'NONE',
  REPORTED: 'REPORTED',
  REPORTING: 'REPORTING'
};

export const REPORT_STATUS_OBJECT = {
  NEW: 'NEW',
  EDIT: 'EDIT',
  REPORT: 'REPORT'
};

export const PRIORITY_REPORT = {
  GREEN: {
    NAME: 'HIGH',
    COLOR: 'bg-palette-emerald-600',
    CODE: 'GREEN'
  },
  YELLOW: {
    NAME: 'MEDIUM',
    COLOR: 'bg-palette-yellow-500',
    CODE: 'YELLOW'
  },
  RED: {
    NAME: 'LOW',
    COLOR: 'bg-palette-red-600',
    CODE: 'RED'
  }
};

export const MODULE_NAME = {
  SOCIAL: 'Social',
  BOOKING: 'Booking'
};

// TODO remove when api return zipCode
export const ZipCode = [
  {
    countryCode: 'VN',
    zipCode: '7000000'
  },
  {
    countryCode: 'US',
    zipCode: '10001'
  }
];

export const TYPE_MANAGEMENT = {
  GROUP: 'GROUP',
  FANPAGE: 'FANPAGE',
  USER: 'USER'
};

export const CATEGORY_FANPAGE_OPTIONS = [{ id: 'TRAVEL_BLOGGER', label: 'Travel blogger' }];

export const GROUP_FANPAGE_STATUS: { [key: string]: any } = {
  NEW: {
    id: 'NEW',
    title: 'GROUP_FANPAGE.NEW'
  },
  PENDING_REVIEW: {
    id: 'PENDING_REVIEW',
    title: 'GROUP_FANPAGE.PENDING_REVIEW'
  },
  EDITED: {
    id: 'EDITED',
    title: 'GROUP_FANPAGE.EDITED'
  },
  WARNING: {
    id: 'WARNING',
    title: 'GROUP_FANPAGE.WARNING'
  },
  DELETED: {
    id: 'DELETED',
    title: 'GROUP_FANPAGE.DELETED'
  },
  INACTIVE: {
    id: 'INACTIVE',
    title: 'GROUP_FANPAGE.INACTIVE'
  },
  BLOCKED: {
    id: 'BLOCKED',
    title: 'GROUP_FANPAGE.BLOCKED'
  },
  ACTIVE: {
    id: 'ACTIVE',
    title: 'GROUP_FANPAGE.ACTIVE_THIS'
  }
};

export const TYPE_STATUS_GROUP_FANPAGE = {
  new: 'NEW',
  pendingReview: 'PENDING_REVIEW',
  edit: 'EDITED',
  blocked: 'BLOCKED',
  warning: 'WARNING',
  inactive: 'INACTIVE',
  active: 'ACTIVE',
  deleted: 'DELETED'
};

export const FILTER_STATUS_GP = {
  NEW: {
    id: 'NEW',
    label: 'New'
  },
  PENDING_REVIEW: {
    id: 'PENDING_REVIEW',
    label: 'Pending review'
  },
  EDITED: {
    id: 'EDITED',
    label: 'Edited'
  },
  WARNING: {
    id: 'WARNING',
    label: 'Warning'
  },
  DELETED: {
    id: 'DELETED',
    label: 'Delete'
  },
  INACTIVE: {
    id: 'INACTIVE',
    label: 'Inactive'
  },
  BLOCKED: {
    id: 'BLOCKED',
    label: 'Blocked'
  }
};

export const USER_ACTIONS = {
  DELETE: {
    label: 'Delete',
    id: 'DELETE',
    icon: 'sctr-icon-trash-02'
  },
  ACTIVE: {
    label: 'Activate',
    id: 'ACTIVATE',
    icon: 'sctr-icon-check-circle'
  },
  BLOCK: {
    label: 'Block',
    id: 'BLOCK',
    icon: 'sctr-icon-lock-03'
  },
  INACTIVE: {
    label: 'Deactivate',
    id: 'DEACTIVATE',
    icon: 'sctr-icon-lock-03'
  },
  VERIFY: {
    label: 'Verify account',
    id: 'VERIFY',
    icon: 'sctr-icon-shield-tick'
  },
  UNVERIFY: {
    label: 'Unverify account',
    id: 'UNVERIFY',
    icon: 'sctr-icon-shield-off'
  },
  UPDATE_BADGE: {
    label: 'Change user badge',
    id: 'UPDATE_BADGE',
    icon: 'sctr-icon-tag-02'
  }
};

export const FANPAGE_GROUP_ACTIONS = {
  BLOCK: {
    label: 'Block',
    id: 'BLOCK',
    icon: 'sctr-icon-lock-03'
  },
  UNBLOCK: {
    label: 'Unblock',
    id: 'UNBLOCK',
    icon: 'sctr-icon-check-circle'
  },
  VERIFY: {
    label: 'Verify',
    id: 'VERIFY',
    icon: 'sctr-icon-shield-tick'
  },
  UNVERIFY: {
    label: 'Unverify',
    id: 'UNVERIFY',
    icon: 'sctr-icon-shield-off'
  },
  UPDATE_BADGE: {
    label: 'Change page badge',
    id: 'UPDATE_BADGE',
    icon: 'sctr-icon-tag-02'
  }
};

export const MODERATE_TYPE = {
  social_admin: 'SOCIAL_MODULE_ADMIN'
};

export const SORT_BY = {
  asc: 'ASC',
  desc: 'DESC'
};

export const STORAGE_FILES = '/storage/files/';

export const TAB_TYPE_CHART = {
  impressions: 'IMPRESSIONS',
  clicks: 'CLICKS',
  ctr: 'CTR',
  conversion: 'CONVERSIONS',
  adsSpent: 'ADS_SPENT',
  reach: 'REACH',
  engagement: 'ENGAGEMENT'
};

export const TAB_TYPE_TOP = {
  ads: 'ADS',
  campaign: 'CAMPAIGN',
  personalAccount: 'PERSONAL_ACCOUNT',
  businessAccount: 'BUSINESS_ACCOUNT'
};

export const LINE_CHART_BACKGROUND_COLOR_RGB = {
  blue: '0,112,245',
  orange: '255,156,102'
};

export const LINE_CHART_COLORS = {
  line: {
    blue: '#1570EF',
    orange: '#FF9C66',
    state: '#98A2B3'
  },
  gray500: '#667085'
};

export const ADS_SUMMARY_TOOLTIP = {
  impressions: 'Number of times an ad is displayed on the network.',
  ctr: 'The ratio of users who click on an ad to the number of total users who view the ad. </br></br> CTR = (Total Impressions / Total clicks) * 100',
  cvr: 'The percentage of users who complete a desired action after clicking on an ad. </br></br> Conversion rate = (Total conversions / Total clicks ) * 100',
  reach:
    'The total number of unique users who have seen the ad at lest once during a specific period.',
  er: 'The percentage of users who interact with an ad out of the total number of impressions. </br></br> Engagement rate = (Total engagement / Total impression) * 100',
  cpe: 'The average cost incurred for each engagement with the ad, where an engagement includes actions such as likes, comments, shares, etc. </br></br> CPE = Total spent amount / Total engagement',
  cpc: 'The average cost per click on the ad. </br></br> CPC = Total spent amount / Total clicks',
  clicks: 'Number of times users click on the ad.',
  reactions:
    'The total number of reactions (e.g. likes, loves, wows, etc.) that the ad receive on Soctrip.',
  comments: 'The total number of comments that the ad receives on Soctrip.',
  shares: 'The number of times users share the ad with others on Soctrip.',
  total_ads_spent: 'The total amount of money spent on advertising campaigns.'
};

export const COUNTRY_LIST: any = {
  us: 'USA',
  vn: 'Viet Nam',
  other: 'Other'
};

export const BRAND: any = {
  SOCTRIP_MASTER: 'Soctrip Master',
  SOCTRIP_STAR: 'Soctrip Star',
  SOCTRIP_XU: 'Soctrip Xu',
  SOCTRIP_BUYER: 'Soctrip Buyer',
  NONE_BADGE: 'None Badge'
};

export const BRAND_VALUE = {
  soctripMaster: 'SOCTRIP_MASTER',
  soctripStar: 'SOCTRIP_STAR',
  noneBadge: 'NONE_BADGE'
};

export const RANK_BRAND: any = {
  BRONZE: 'Bronze',
  SILVER: 'Silver',
  GOLD: 'Gold',
  DIAMOND: 'Diamond'
};

export const BadgeList = [
  { label: BRAND.SOCTRIP_MASTER, id: 'SOCTRIP_MASTER', disabled: false },
  { label: BRAND.SOCTRIP_STAR, id: 'SOCTRIP_STAR', disabled: false }
];

export const NoneBadge = { label: BRAND.NONE_BADGE, id: 'NONE_BADGE', disabled: false };

export const BadgeRankList = [
  { label: RANK_BRAND.BRONZE, id: 'BRONZE' },
  { label: RANK_BRAND.SILVER, id: 'SILVER' },
  { label: RANK_BRAND.GOLD, id: 'GOLD' },
  { label: RANK_BRAND.DIAMOND, id: 'DIAMOND' }
];

export const AVATAR_TYPE = {
  ringWithBorder: 'RING_WITH_BORDER',
  ring: 'RING',
  whiteBorder: 'WHITE_BORDER',
  grayBorder: 'GRAY_BORDER'
};

export const AVATAR_SIZE = {
  desktopProfile: {
    widthHeight: 'w-[150px] h-[150px]',
    ringPadding: 'p-1',
    initialsAvatar: 'text-6xl font-bold'
  },
  mobileProfile: {
    widthHeight: 'w-[140px] h-[140px]',
    ringPadding: 'p-[3px]',
    initialsAvatar: 'text-6xl font-bold'
  },
  small: {
    widthHeight: 'w-[46px] h-[46px]',
    ringPadding: 'p-[2px]',
    initialsAvatar: 'text-lg font-bold'
  },
  tiny: {
    widthHeight: 'w-6 h-6',
    ringPadding: 'p-[1px]',
    initialsAvatar: 'text-xs font-bold'
  },
  fanpageList: {
    widthHeight: 'w-16 h-16 md:w-20 md:h-20 lg:w-24 lg:h-24',
    ringPadding: 'p-[1px]',
    initialsAvatar: 'text-lg font-bold'
  }
};

export const PRIVILEGE = {
  newsFeed: 'suggest_new_feed'
};

export const PermissionCode = {
  superAdmin: 'SUPER_ADMIN',
  userDashboardAccess: 'SOCIAL_USER_DASHBOARD_ACCESS',
  fanpageDashboardAccess: 'SOCIAL_FANPAGE_DASHBOARD_ACCESS',
  groupDashboardAccess: 'SOCIAL_GROUP_DASHBOARD_ACCESS',
  adsAccess: 'SOCIAL_ADS_ACCESS',
  adsView: 'SOCIAL_ADS_VIEW',
  adsWarning: 'SOCIAL_ADS_WARNING',
  adsSuspend: 'SOCIAL_ADS_SUSPEND',
  adsRevert: 'SOCIAL_ADS_REVERT',
  adsAccountAccess: 'SOCIAL_ADS_ACCOUNT_ACCESS',
  adsAccountView: 'SOCIAL_ADS_ACCOUNT_VIEW',
  adsAccountWarning: 'SOCIAL_ADS_ACCOUNT_WARNING',
  adsAccountSuspend: 'SOCIAL_ADS_ACCOUNT_SUSPEND',
  adsAccountRevert: 'SOCIAL_ADS_ACCOUNT_REVERT',
  userManagementAccess: 'SOCIAL_USER_ACCESS',
  userManagementBlock: 'SOCIAL_USER_BLOCK',
  userManagementUnblock: 'SOCIAL_USER_UNBLOCK',
  userManagementVerify: 'SOCIAL_USER_VERIFY',
  userManagementBadge: 'SOCIAL_USER_BADGE',
  userManagementDelete: 'SOCIAL_USER_DELETE',
  userManagementActive: 'SOCIAL_USER_ACTIVE',
  userManagementUnVerify: 'SOCIAL_USER_UNVERIFY',
  groupManagementAccess: 'SOCIAL_GROUP_ACCESS',
  groupManagementBlock: 'SOCIAL_GROUP_BLOCK',
  groupManagementUnblock: 'SOCIAL_GROUP_UNBLOCK',
  fanpageManagementAccess: 'SOCIAL_FANPAGE_ACCESS',
  fanpageManagementBlock: 'SOCIAL_FANPAGE_BLOCK',
  fanpageManagementUnblock: 'SOCIAL_FANPAGE_UNBLOCK',
  fanpageManagementVerify: 'SOCIAL_FANPAGE_VERIFY',
  fanpageManagementUnVerify: 'SOCIAL_FANPAGE_UNVERIFY',
  fanpageManagementBadge: 'SOCIAL_FANPAGE_BADGE',
  feeAccess: 'SOCIAL_FEE_ACCESS',
  feeEdit: 'SOCIAL_FEE_EDIT',
  feeCreateProfile: 'SOCIAL_FEE_CREATE_PROFILE',
  feeByRegionAccess: 'SOCIAL_FEE_BY_REGION_ACCESS',
  feeByRegionEdit: 'SOCIAL_FEE_BY_REGION_EDIT',
  feeByRegionCreateProfile: 'SOCIAL_FEE_BY_REGION_CREATE_PROFILE',
  feedbackAccess: 'SOCIAL_FEEDBACK_ACCESS',
  affiliateAccess: 'SOCIAL_AFFILIATE_ACCESS',
  affiliateAdd: 'SOCIAL_AFFILIATE_ADD',
  affiliateDelete: 'SOCIAL_AFFILIATE_DELETE',
  faqAccess: 'CHAT_FAQ_ACCESS',
  pinAccess: 'SOCIAL_PIN_ACCESS',
  pinAdd: 'SOCIAL_PIN_ADD',
  pinRemove: 'SOCIAL_PIN_REMOVE',
  livestreamConfigAccess: 'SOCIAL_LIVESTREAM_GIFT_ACCESS',
  livestreamConfigAdd: 'SOCIAL_LIVESTREAM_GIFT_ADD',
  livestreamConfigEdit: 'SOCIAL_LIVESTREAM_GIFT_EDIT',
  livestreamConfigDelete: 'SOCIAL_LIVESTREAM_GIFT_DELETE',
  chatAccess: 'CHAT_SUPPORT_ACCESS',
  socPointManagementAccess: 'SOCIAL_SOCPOINT_MANAGEMENT_ACCESS'
};

export const AdsAccessCodeList = [
  PermissionCode.adsAccess,
  PermissionCode.adsSuspend,
  PermissionCode.adsView,
  PermissionCode.adsWarning
];

export const AdsAccountAccessCodeList = [
  PermissionCode.adsAccountAccess,
  PermissionCode.adsAccountView,
  PermissionCode.adsAccountWarning,
  PermissionCode.adsAccountSuspend
];

export const UserManagementAccessCodeList = [
  PermissionCode.userManagementAccess,
  PermissionCode.userManagementBlock,
  PermissionCode.userManagementUnblock,
  PermissionCode.userManagementVerify,
  PermissionCode.userManagementBadge,
  PermissionCode.userManagementDelete,
  PermissionCode.userManagementActive,
  PermissionCode.userManagementUnVerify
];

export const GroupManagementAccessCodeList = [
  PermissionCode.groupManagementAccess,
  PermissionCode.groupManagementBlock,
  PermissionCode.groupManagementUnblock
];

export const FanpageManagementAccessCodeList = [
  PermissionCode.fanpageManagementAccess,
  PermissionCode.fanpageManagementBlock,
  PermissionCode.fanpageManagementUnblock,
  PermissionCode.fanpageManagementVerify,
  PermissionCode.fanpageManagementUnVerify,
  PermissionCode.fanpageManagementBadge
];

export const FeeAccessCodeList = [
  PermissionCode.feeAccess,
  PermissionCode.feeEdit,
  PermissionCode.feeCreateProfile
];

export const FeeByRegionAccessCodeList = [
  PermissionCode.feeByRegionAccess,
  PermissionCode.feeByRegionEdit,
  PermissionCode.feeByRegionCreateProfile
];

export const AffiliateAccessCodeList = [
  PermissionCode.affiliateAccess,
  PermissionCode.affiliateAdd,
  PermissionCode.affiliateDelete
];

export const PinAccessCodeList = [
  PermissionCode.pinAccess,
  PermissionCode.pinAdd,
  PermissionCode.pinRemove
];

export const LivestreamConfigAccessCodeList = [
  PermissionCode.livestreamConfigAccess,
  PermissionCode.livestreamConfigAdd,
  PermissionCode.livestreamConfigEdit,
  PermissionCode.livestreamConfigDelete
];

export const MIN_LOADING_TIME = 200;
export const TOP_TABLE_SKELETON_ROWS = 5;
export const TOP_TABLE_SKELETON_COLUMNS = 3;

export const TAG_STYLE_CLASS = {
  blue: 'bg-palette-blue-100 text-palette-blue-600',
  green: 'bg-palette-green-50 text-palette-green-600',
  orange: 'bg-palette-amber-50 text-palette-amber-600',
  red: 'bg-palette-red-50 text-palette-red-600',
  purple: 'bg-palette-violet-50 text-palette-violet-600',
  gray: 'bg-palette-gray-50 text-palette-gray-700',
  moreGray: 'bg-palette-gray-100 text-palette-gray-700'
};

export const LANGUAGE_LOCALES_MAP = new Map<string, string>([
  ['en', 'en-US'],
  ['vi', 'vi-VN']
]);

export const CURRENCY_LOCALES_MAP = new Map<string, string[]>([
  ['USD', ['en-US', 'en-CA', 'en-PH']],
  ['VND', ['vi-VN']],
  ['EUR', ['de-DE', 'fr-FR', 'es-ES', 'it-IT', 'nl-NL', 'pt-PT', 'fi-FI']],
  ['INR', ['en-IN', 'hi-IN']],
  ['AUD', ['en-AU', 'en-NZ', 'en-SG']]
]);
